import { User } from "@/assets";
import { useEffect, useState, type CSSProperties } from "react";
import { colors } from "@/styling";

type AvatarProps = {
  src?: string | null;
  size?: number;
  width?: number;
};

const Avatar = ({ src, size, width }: AvatarProps) => {
  const fluid = width != null;
  const w = fluid ? width : (size ?? 44);
  const h = fluid ? ("auto" as const) : (size ?? 44);
  const clean = (src ?? "").trim();
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [clean]);

  const showPhoto = Boolean(clean) && !imageFailed;

  if (!showPhoto) {
    const shell: CSSProperties = fluid
      ? {
          width: w,
          aspectRatio: "1",
          borderRadius: "50%",
          backgroundColor: colors.whisper,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }
      : {
          width: w,
          height: h,
          borderRadius: "50%",
          // backgroundColor: colors.whisper,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        };

    return (
      <span style={shell} aria-hidden>
        <User style={{ width: "55%", height: "55%", flexShrink: 0 }} />
      </span>
    );
  }

  return (
    <img
      src={clean}
      alt=""
      style={{
        width: w,
        height: h,
        borderRadius: "50%",
        display: fluid ? "block" : undefined,
        objectFit: fluid ? undefined : "cover",
      }}
      onError={() => setImageFailed(true)}
    />
  );
};

export default Avatar;
